import {LABEL_MAIN_TYPE_GET , LABEL_MAIN_TYPE_SUCCESS,LABEL_MAIN_TYPE_FAILURE } from './actions';

const initialState = {
    order: {}
}

export function LabelMainTypeReducer(state = initialState, action) {
    
    if(action.type === LABEL_MAIN_TYPE_GET) {
        return state;
    }
    if(action.type === LABEL_MAIN_TYPE_SUCCESS) {
        return {
            ...state,
            order: {
                isLoaded: true,
                data: action.payload,
                message: 'Success'
            }
        }
    }
    if(action.type === LABEL_MAIN_TYPE_FAILURE) {
        return {
            ...state,
            order: {
                data: [],
                message: action.payload
            }
        }
    }
    return state;
}

